import { useState, useEffect } from "react";
import {
  Backdrop, Box, Button, Card, CardActions, CardContent, CardMedia,
  CircularProgress, Container, FormControl, Grid, InputLabel, Select,
  TextField
} from "@mui/material";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import CheckAttr from "../../../utils/CheckAttr";
import { AlertType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import { urlApi } from "../parametrage/Pays/RowPays";
import Cookies from "universal-cookie";
import { DataRef } from "../../../types/DataRef";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loggoutUser } from "../../../redux/actions/logginUser";
import axios, { AxiosInstance } from "axios";

const FacturePro = () => {
  // Data Ref
  const [allClient, setAllClient] = useState<DataRef[]>();
  const [allOperation, setAllOperation] = useState<DataRef[]>();

  // Selected
  const [clientSelected, setClientSelected] = useState<DataRef>();
  const [operationSelected, setOperationSelected] = useState<DataRef>();
  const [dateDebut, setDateDebut] = useState<string>();
  const [dateFin, setDateFin] = useState<string>();

  // Error
  const [errorInput, setErrorInput] =
    useState<InputValidation>(resetInpuValidation);
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);

  // Axios
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  // Autre
  const [loader, setLoader] = useState<boolean>(false);

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });



  const navigate = useNavigate();
  const dispatch = useDispatch();


  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    if (!CheckAttr(clientSelected?.id) || !CheckAttr(dateDebut) || !CheckAttr(dateFin)) {
      !CheckAttr(clientSelected?.id) && setErrorInput((prev: InputValidation) => ({
        ...prev,
        client: true,
      }));

      !CheckAttr(dateDebut) && setErrorInput((prev: InputValidation) => ({
        ...prev,
        dateDebut: true,
      }));

      !CheckAttr(dateFin) && setErrorInput((prev: InputValidation) => ({
        ...prev,
        dateFin: true,
      }));

      setAlerteMessage("Merci de remplir les champs en rouge SVP!");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    }

    return true;
  };

  const handleChange = (e: any) => {
    if (e.target.name === 'client') {
      setClientSelected(allClient?.find((x) => x.id == e.target.value));
      setOperationSelected((allOperation?.find((x) => x.id == 0)));

      // Get Operation Du Client
      if (e.target.value !== 0 && e.target.value !== "") {
        setLoader(true);
        http.get(`operation/byclient/${e.target.value}`)
          .then(res => {
            Array.isArray(res.data) && setAllOperation(res.data);
          }).catch(error => {
            console.log(error);
          }).finally(() => {
            setLoader(false);
          });
      }
    }

    if (e.target.name === 'operation') {
      setOperationSelected((allOperation?.find((x) => x.id == e.target.value)))
    }

    if (e.target.name === 'date_debut') {
      setDateDebut(e.target.value);
    }

    if (e.target.name === 'date_fin') {
      setDateFin(e.target.value);
    }
  };

  // Action
  const getAllClient = () => {
    setLoader(true);
    http.get(`client/get/byManager`)
      .then((res) => {
        setAllClient(res.data);
      })
      .catch((err) => {
        console.log(err);
      }).finally(() => {
        setLoader(false);
      });
  };

  const handleExtract = () => {
    if (isValidate()) {
      const data = {
        "clientId": clientSelected?.id,
        "operationId": operationSelected?.id,
        "dateDebut": dateDebut,
        "dateFin": dateFin
      };

      setLoader(true);
      http.post(`facturation/proforma`, data)
        .then((res) => {
          if (res.data.length !== 0) {
            setAlerteMessage("Extraction achevée");
            setAlertType("success");
          } else {
            setAlerteMessage("il ñ'y a pas encore de factures pour le moment");
            setAlertType("warning");
          }

          setOpenSnack(true);

          res.data.map((fileName: string) => window.open(`${urlApi}down/excel/${fileName}`));
        }).catch((error) => {
          console.log(error);
          setAlertType("error");
          setOpenSnack(true);
        }).finally(() => {
          setLoader(false);
        });
    }
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  useEffect(() => {
    getAllClient();
  }, []);

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 10 }}>
        <Card sx={{ maxWidth: 845 }}>
          <CardMedia
            component="img"
            height="140"
            image="/images/facturepro.png"
            alt="green iguana"
            sx={{ display: { xs: 'none', sm: 'flex' } }}
          />
          <CardContent>
            <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                >
                  <InputLabel
                    htmlFor="client"
                    color="warning"
                    shrink={CheckAttr(clientSelected?.id)}
                    error={errorInput.client}
                  >
                    Marque Client
                  </InputLabel>
                  <Select
                    id="client"
                    native
                    color="warning"
                    value={
                      clientSelected?.id !== undefined
                        ? clientSelected?.id
                        : ""
                    }
                    onChange={handleChange}
                    label="Client"
                    inputProps={{
                      name: "client",
                    }}
                    error={errorInput.client}
                  >
                    <option value=""></option>
                    {allClient?.map((cl) => (
                      <option key={cl?.id} value={cl?.id}>
                        {cl?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  name="date_debut"
                  label="Date debut"
                  type="date"
                  color="warning"
                  fullWidth
                  sx={{ mt: 2 }}
                  error={errorInput.dateDebut}
                  value={dateDebut}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                >
                  <InputLabel
                    htmlFor="client"
                    color="warning"
                    shrink={CheckAttr(operationSelected?.id)}
                  >
                    Operation
                  </InputLabel>
                  <Select
                    id="operation"
                    native
                    color="warning"
                    value={
                      operationSelected?.id
                    }
                    onChange={handleChange}
                    label="Client"
                    inputProps={{
                      name: "operation",
                    }}
                  >
                    <option value=""></option>
                    {allOperation?.map((op) => (
                      <option key={op?.id} value={op?.id}>
                        {op?.libelle}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  name="date_fin"
                  label="Date fin"
                  type="date"
                  color="warning"
                  fullWidth
                  sx={{ mt: 2 }}
                  error={errorInput.dateFin}
                  value={dateFin}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>

          <CardActions>
            <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color="warning"
                    size="large"
                    sx={{ textTransform: 'none' }}
                    endIcon={<CreateNewFolderIcon />}
                    onClick={() => handleExtract()}
                  >
                    Extraire Facture
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Container>

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      {stackAlert}
    </>
  );
};

export default FacturePro;

interface InputValidation {
  client: boolean;
  dateDebut: boolean;
  dateFin: boolean;
}

const resetInpuValidation: InputValidation = {
  client: false,
  dateDebut: false,
  dateFin: false
};
